import loadingImg from "web/images/loading.gif"

export default function Loading({ isLoading }) {
  if (!isLoading) {
    return null
  }

  return <img src={loadingImg} alt="loading" width="20px" />
}
